import React, { useState, useEffect, useRef } from "react"
import {
  sortData,
  downloadPdfFromBase64,
  formatFaxNumber,
  isEmpty,
} from "../../utils/common"
import { post, get, remove, put } from "../../utils/apiClient"
import Pagination from "../common/paginationBe"
import moment from "moment-timezone"
import toast from "react-hot-toast"
import SendFaxFormModal from "./../sendFaxFormModal"
import {
  IN_OUT_BOUND,
  DEFAULT_APP_ID,
  PERSONAL_FAX,
} from "../../utils/constants"
import FaxView from "../../components/faxView"
import PhonebookModal from "../../components/settingTabs/phonebookModal"

import {
  Copy,
  ArrowDownUp,
  ArrowUp,
  ArrowDown,
  Undo2,
  Trash2,
  StepForward,
  Download,
  RefreshCcw,
  View,
  FileX,
  ArrowBigLeft,
  TriangleAlert,
  EyeOff,
  SquarePlus,
  SquarePen,
  SquareX,
  PhoneForwarded,
  toggleOwnMUSCSender,
} from "lucide-react"

const BoundInOut = ({
  selectedQueue,
  selectedFax,
  setSelectedFax,
  tab,
  searchText,
  searchBy,
  reloadQueues,
  authUser,
  queueList,
  allPermissions,
  reloadKey,
  setReloadSubfolderCount,
  dateRange,
  //searchButtonFlg,
  setSearchText,
  toggleOwnMUSCSender,
}) => {
  const [faxes, setFaxes] = useState([])
  const [faxToCopy, setFaxToCopy] = useState(null)
  const [faxToUndo, setFaxToUndo] = useState(null)
  const [faxToTrash, setFaxToTrash] = useState(null)
  const [sortConfig, setSortConfig] = useState({
    key: "completed_timestamp",
    direction: "desc",
  })
  const [listLoading, setListLoading] = useState(false)
  const [actionLoading, setActionLoading] = useState(false)
  const [showFFPopup, setShowFFPopup] = useState(null)
  const [loadingDownload, setLoadingDownload] = useState(null)
  const [faxView, setFaxView] = useState(null)
  const [showCancelPopup, setShowCancelPopup] = useState(null)
  const [showUnreadPopup, setShowUnreadPopup] = useState(null)
  const [paginationOffset, setPaginationOffset] = useState(0)
  const [addCommentPopup, setAddCommentPopup] = useState(null)
  const [editCommentPopup, setEditCommentPopup] = useState(null)
  const [deleteCommentPopup, setDeleteCommentPopup] = useState(null)
  const [destinationfaxNumbers, setDestinationfaxNumbers] = useState([])
  const [destinationFaxNumberLoading, setDestinationFaxNumberLoading] =
    useState(false)

  const [showPhonebookPopup, setShowPhonebookPopup] = useState(null)
  const [copiedFaxType, setCopiedFaxType] = useState("INBOUND")

  const prevSearchByRef = useRef()
  const prevSearchTextRef = useRef()

  // Pagination
  const [lastRecord, setLastRecord] = useState(0)

  // Fields to display
  let fields = [
    {
      key: "originating_fax_tsid",
      label: "Originating Fax Number",
      fixed: true,
      style: { width: "150px" },
    },
    {
      key: "completed_timestamp",
      label: "Received",
      sort: true,
      style: { width: "200px" },
    },
    { key: "pages", label: "Pages", style: { width: "200px" } },
    {
      key: "copiedToSubfolder",
      label: "Copied To",
      hide: selectedQueue?.sectionType === "netId" ? true : false,
      style: { width: "200px" },
    },
    { key: "fax_id", label: "Fax Id", style: { width: "100px" } },
    {
      key: "comment1",
      label: "Comment1",
      hide: dateRange?.length > 0 ? true : false,
      style: { width: "300px", textAlign: "left" },
    },
    {
      key: "comment2",
      label: "Comment2",
      hide: dateRange?.length > 0 ? true : false,
      style: { width: "300px", textAlign: "left" },
    },
    {
      key: "comment3",
      label: "Comment3",
      hide: dateRange?.length > 0 ? true : false,
      style: { width: "300px", textAlign: "left" },
    },
  ]

  if (tab === "outbound") {
    fields = [
      {
        key: "destination_fax_csid",
        label: "Destination",
        sort: true,
        fixed: true,
        style: { width: "200px" },
      }, // Fixed column
      {
        key: "completed_timestamp",
        label: "Transmission Time",
        sort: true,
        style: { width: "160px" },
      },
      { key: "pages", label: "Pages", style: { width: "70px" } },
      {
        key: "transmission_data.transmission_status",
        label: "Status",
        sort: true,
      },
      { key: "routing_data", label: "Routing" },
      {
        key: "copiedToSubfolder",
        label: "Copied To",
        hide: selectedQueue?.sectionType === "netId" ? true : false,
      },
      { key: "client_tracking_data.client_matter", label: "Comment1" },
      { key: "client_tracking_data.client_name", label: "Comment2" },
      { key: "fax_id", label: "Fax ID", style: { width: "100px" } },
      { key: "muscSender", label: "Sender" },
    ]
  }

  if (tab === "inbound" && selectedQueue?.type === "subfolder") {
    fields = [
      { key: "displayFaxNumber", label: "Fax Number", sort: true },
      { key: "faxType", label: "Fax Type" },
      { key: "pages", label: "Pages" },
      { key: "copiedByNetId", label: "Copied By NetId" },
      { key: "completedTimestamp", label: "Completed At", sort: true },
      { key: "comment1", label: "Comment1", showFor: "INBOUND" },
      { key: "comment2", label: "Comment2", showFor: "INBOUND" },
      { key: "comment3", label: "Comment3", showFor: "INBOUND" },
      { key: "outboundComment1", label: "Comment1", showFor: "OUTBOUND" },
      { key: "outboundComment2", label: "Comment2", showFor: "OUTBOUND" },
      { key: "faxId", label: "Fax Id", style: { width: "100px" } },
    ]
  }

  // Search Filter

  const filterByField = () => {
    if (searchText.trim() === "") {
      return faxes
    }

    if (searchBy === "") {
      // Search by default
      return faxes?.filter((fax) => {
        if (fax.fax_trashed) return false

        const search = searchText.toLowerCase()

        return (
          fax.originating_fax_tsid
            ?.toLowerCase()
            .includes(search.replace(/-/g, "").toLowerCase()) ||
          fax.copiedToSubfolder?.toLowerCase().includes(search) ||
          fax.comment1?.toLowerCase().includes(search) ||
          fax.comment2?.toLowerCase().includes(search) ||
          fax.comment3?.toLowerCase().includes(search) ||
          fax.fax_id?.toLowerCase().includes(search) ||
          fax[searchBy]?.toString().toLowerCase().includes(search)
        )
      })
    } else {
      // Search by selected field
      // return faxes?.filter((fax) => {
      //   if (fax.fax_trashed) return false

      //   const search = searchText.toLowerCase()

      //   console.log(searchBy)

      //   switch (searchBy) {
      //     default:
      //       const value = fax[searchBy]
      //       return value?.toString().toLowerCase().includes(search)
      //   }
      // })

      return faxes?.filter((fax) => {
        if (fax.fax_trashed) return false

        const search = searchText.toLowerCase()

        switch (searchBy) {
          case "comment":
            // check across all three comment fields
            return (
              fax.comment1?.toString().toLowerCase().includes(search) ||
              fax.comment2?.toString().toLowerCase().includes(search) ||
              fax.comment3?.toString().toLowerCase().includes(search)
            )

          default:
            const value = fax[searchBy]
            return value?.toString().toLowerCase().includes(search)
        }
      })
    }
  }

  const filterByAll = () => {
    if (searchText.trim() === "") {
      return faxes
    }

    return faxes?.filter((fax) => {
      if (fax.fax_trashed) return false

      const search = searchText.toLowerCase()

      const faxIdMatch = fax?.faxId
        ? fax?.faxId.toLowerCase().includes(search)
        : false

      const faxId2Match = fax?.fax_id
        ? fax?.fax_id.toLowerCase().includes(search)
        : false

      // Check routing_data
      const destinationMatch = fax?.destination_fax_csid
        ? fax?.destination_fax_csid
            .toLowerCase()
            .includes(search.replace(/-/g, "").toLowerCase())
        : false

      // Check completed_timestamp
      const timestampMatch = fax.completed_timestamp
        ? moment
            .utc(fax.completed_timestamp)
            .tz("America/New_York")
            .format("MM/DD/YYYY hh:mm A")
            .toLowerCase()
            .includes(search)
        : false

      // Check routing_data
      const routing = fax.routing_data || {}
      const routingMatch = `${routing.to_name || ""}${routing.to_company || ""}`
        .toLowerCase()
        .includes(search)

      // Check client_tracking_data
      const client = fax.client_tracking_data || {}
      const clientMatch = `${client.client_matter || ""}${
        client.client_name || ""
      }`
        .toLowerCase()
        .includes(search)

      const displayFaxNumberMatch = fax?.faxId
        ? fax?.displayFaxNumber
            .toLowerCase()
            .includes(search.replace(/-/g, "").toLowerCase())
        : false

      const copiedByNetIdMatch = fax?.faxId
        ? fax?.copiedByNetId.toLowerCase().includes(search)
        : false

      const muscSenderMatch = fax?.muscSender
        ? fax?.muscSender.toLowerCase().includes(search)
        : false

      const comment1Match = fax?.comment1
        ? fax?.comment1.toLowerCase().includes(search)
        : false

      const comment2Match = fax?.comment2
        ? fax?.comment2.toLowerCase().includes(search)
        : false

      const comment3Match = fax?.comment3
        ? fax?.comment3.toLowerCase().includes(search)
        : false

      const outboundComment1Match = fax?.outboundComment1
        ? fax?.outboundComment1.toLowerCase().includes(search)
        : false

      const outboundComment2Match = fax?.outboundComment2
        ? fax?.outboundComment2.toLowerCase().includes(search)
        : false

      // Only return if any of the key fields match
      return (
        faxIdMatch ||
        faxId2Match ||
        destinationMatch ||
        timestampMatch ||
        routingMatch ||
        clientMatch ||
        displayFaxNumberMatch ||
        copiedByNetIdMatch ||
        muscSenderMatch ||
        comment1Match ||
        comment2Match ||
        comment3Match ||
        outboundComment1Match ||
        outboundComment2Match
      )
    })
  }

  const getFilteredFaxes = () => {
    if (searchBy === "originating_fax_tsid") {
      return faxes
    } else {
      if (
        tab === "inbound" &&
        selectedQueue?.type !== "subfolder" &&
        searchText !== ""
      ) {
        return filterByField() // queue/netid -> inbound
      } else {
        return filterByAll()
      }
    }
  }

  let filteredFaxes = getFilteredFaxes()
  if (toggleOwnMUSCSender && tab === "outbound") {
    // MUSC SENDER TOGGLE FILTER
    filteredFaxes = filteredFaxes.filter((fax) =>
      fax?.client_tracking_data?.client_reference_id?.includes(authUser.netId)
    )
  } else if (
    // INBOUND faxes for subfolder
    selectedQueue?.type === "subfolder" &&
    copiedFaxType === "INBOUND"
  ) {
    filteredFaxes = filteredFaxes.filter((fax) => fax.faxType === "INBOUND")
  } else if (
    // OUTBOUND faxes for subfolder
    selectedQueue?.type === "subfolder" &&
    copiedFaxType === "OUTBOUND"
  ) {
    filteredFaxes = filteredFaxes.filter((fax) => fax.faxType === "OUTBOUND")
  }

  const currentFaxes = sortData(filteredFaxes, sortConfig)

  const fetchFaxes = async (notifyError = false, fromSearch = false) => {
    if (selectedQueue && Object.keys(selectedQueue)?.length === 0) {
      return
    }

    if (["inbound", "outbound"].includes(tab) && selectedQueue) {
      if (
        (selectedQueue?.faxNumber === PERSONAL_FAX ||
          selectedQueue?.parentKey === "userPersonalFax") &&
        tab === "inbound"
      ) {
        // Personal fax: No need to hit call of inbound
        return
      }
      try {
        let subFolderIobUrl = `/fax/netId-subfolder-copied-faxes-associations?netId=${selectedQueue?.netId}&subFolder=${selectedQueue?.subFolder}`
        let queueNetParams = {
          netId:
            selectedQueue.faxNumber === PERSONAL_FAX &&
            authUser.loggedInUserType === "USER"
              ? authUser.netId // Personal fax: authUser.netId
              : selectedQueue.netId,
        }
        if (selectedQueue?.sectionType === "queue") {
          subFolderIobUrl = `/fax/queue-subfolder-copied-faxes-associations?queueName=${selectedQueue?.queue}&subFolder=${selectedQueue?.subFolder}`
          queueNetParams = { queue: selectedQueue?.queue }
        }

        let ibUrl = `/fax/inboundFaxes`
        if (selectedQueue?.type === "subfolder") {
          ibUrl = subFolderIobUrl
        }

        let obUrl = `/fax/outboundFaxes`
        if (selectedQueue.type === "subfolder") {
          obUrl = subFolderIobUrl
        }

        let url = tab === "inbound" ? ibUrl : obUrl

        const dateParams =
          dateRange?.length > 0 && selectedQueue && tab === "inbound"
            ? { minTS: dateRange[0], maxTS: dateRange[1] }
            : {}

        let searchParams = {}
        if (searchBy === "originating_fax_tsid" && !isEmpty(searchText)) {
          searchParams = {
            searchText: searchText.replace(/-/g, "").toLowerCase(),
          }
        }

        let data = []
        if (selectedQueue.type === "subfolder") {
          data = await get(url)
          setFaxes(data)
        } else {
          data = await post(
            url,
            {
              userId: selectedQueue.userId,
              ...queueNetParams,
              ...dateParams,
              ...searchParams,
              paginationOffset: fromSearch ? 0 : paginationOffset,
              personalFax:
                selectedQueue?.faxNumber === PERSONAL_FAX ||
                selectedQueue?.parentKey === "userPersonalFax", // Personal fax: true
            },
            {
              appId: selectedQueue?.appId,
            }
          )

          setFaxes(data.faxes)

          // Pagination
          // setFirstRecord(Number(data.first_record))
          setLastRecord(Number(data.last_record))
          // const totalCount = data.total_count || data.faxes.length
          // setTotalPages(Math.ceil(totalCount / 10))
          // setCurrentPage(page)
        }

        setListLoading(false)
      } catch (err) {
        setListLoading(false)
        setFaxes([])
        if (notifyError) {
          toast.error(err, {
            duration: 5000,
          })
        }
      }
    }
  }

  const fetchDestinationFaxNumbers = async () => {
    setDestinationFaxNumberLoading(true)

    let type = "PERSONAL"
    let qString = ""
    if (selectedQueue.sectionType === "queue") {
      type = "QUEUE"
      qString = `?queue=${selectedQueue?.queue}`
    }

    try {
      const faxNumbers = await get(`/phoneBook/${type}${qString}`)

      setDestinationfaxNumbers(faxNumbers)
      setDestinationFaxNumberLoading(false)
    } catch (error) {
      console.error("Failed to fetch fetchFaxNumbers", error)
      setDestinationFaxNumberLoading(false)
    }
  }

  const downloadPdf = async (fax) => {
    try {
      setLoadingDownload(fax.fax_id)

      // let headers = { appId: selectedQueue?.appId || DEFAULT_APP_ID }
      // if (selectedQueue?.type !== "subfolder") {
      const headers = {
        faxNumber:
          tab === "outbound"
            ? fax?.destination_fax_csid || fax?.destination_fax_number
            : fax?.originating_fax_tsid,
        faxAction: IN_OUT_BOUND["download"],
        appId: selectedQueue?.appId || selectedFax?.appId || DEFAULT_APP_ID,
      }
      // }

      const data = await post(
        `/fax/image`,
        {
          userId: selectedQueue?.userId,
          faxId: fax.fax_id,
        },
        headers
      )

      if (data?.image) {
        // const byteCharacters = atob(data?.image)
        // const byteNumbers = new Array(byteCharacters.length)
        // for (let i = 0; i < byteCharacters.length; i++) {
        //   byteNumbers[i] = byteCharacters.charCodeAt(i)
        // }
        // const byteArray = new Uint8Array(byteNumbers)
        // const blob = new Blob([byteArray], { type: "application/pdf" })

        // // Update state to pass the Blob to the Document component
        // setPdfUrl(blob)
        downloadPdfFromBase64(data?.image, `${fax.fax_id}.pdf`)
        //setDocument(data?.image)
      }

      setLoadingDownload(false)
    } catch (err) {
      toast.error(err, {
        duration: 5000,
      })
      setLoadingDownload(false)
    }
  }

  const handleCopySubmit = async (appConfig, type = "trash") => {
    setActionLoading(true)
    try {
      let url = "/fax/netId-subfolder-copied-faxes-association"
      if (appConfig?.queueName) {
        url = "/fax/queue-subfolder-copied-faxes-association"
      }
      const res = await put(url, appConfig)
      setFaxToCopy(null)
      setFaxToTrash(null)
      toast.success(res.message)
      await fetchFaxes()
      await reloadQueues()

      setReloadSubfolderCount({
        queueName: appConfig?.queueName,
        subFolder: appConfig?.subFolder,
        action: "copy",
      })
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
    } finally {
      setFaxToCopy(null)
      setFaxToTrash(null)
      setActionLoading(false)
    }
  }

  const handleUndoSubmit = async (undoData) => {
    setActionLoading(true)
    try {
      let url = `/fax/queue-subfolder-copied-faxes-association/${undoData.queueName}/${undoData.subFolder}/${undoData.faxId}`
      if (selectedQueue.sectionType === "netId") {
        url = `/fax/netId-subfolder-copied-faxes-association/${undoData.netId}/${undoData.subFolder}/${undoData.faxId}`
      }

      const res = await remove(url)
      setFaxToUndo(null)
      await fetchFaxes()
      await reloadQueues()
      setReloadSubfolderCount({
        queueName: undoData?.queueName,
        subFolder: undoData?.subFolder,
        action: "delete",
      })
      toast.success(res.message)
    } catch (error) {
      toast.error("Failed to Undo")
    } finally {
      setFaxToUndo(null)
      setActionLoading(false)
    }
  }

  const handleDeleteSubmit = async (trashData) => {
    setActionLoading(true)
    // Permenent delete from subfolder trash
    if (
      trashData?.subFolder === "Trash" ||
      selectedQueue?.faxNumber === PERSONAL_FAX
    ) {
      let queueNetId = { netId: trashData?.netId }
      if (selectedQueue?.faxNumber === PERSONAL_FAX) {
        queueNetId = { netId: authUser.netId }
      } else if (trashData?.queueName) {
        queueNetId = { queue: trashData?.queueName }
      }

      try {
        const res = await post(
          `/fax/delete`,
          {
            userId: trashData.userId,
            faxId: trashData.faxId,
            ...queueNetId,
          },
          {
            appId: selectedQueue?.appId,
            faxNumber: trashData?.displayFaxNumber || trashData?.faxNumber,
          }
        )
        setFaxToTrash()
        await fetchFaxes()
        //await reloadQueues()

        setReloadSubfolderCount({
          queueName: trashData?.queueName,
          subFolder: trashData?.subFolder,
          action: "delete",
        })

        toast.success(res.message)
        setActionLoading(false)
      } catch (error) {
        toast.error(error, {
          duration: 5000,
        })
        setActionLoading(false)
      }
    } else {
      // Move to trash from queue or netid
      const params = {
        faxId: trashData.fax_id,
        appId: selectedQueue?.appId,
        userId: selectedQueue?.userId,
        faxNumber: trashData.destination_fax_number,
        pages: trashData.pages,
        faxStatus: trashData.fax_status,
        faxType: tab === "outbound" ? "OUTBOUND" : "INBOUND",
        displayFaxNumber:
          tab === "outbound"
            ? trashData?.destination_fax_csid ||
              trashData?.destination_fax_number
            : trashData?.originating_fax_tsid,
        completedTimestamp: moment
          .utc(trashData.completed_timestamp)
          .tz("America/New_York")
          .format("MM/DD/YYYY hh:mm A"),
      }

      let obj = {
        netId: selectedQueue.netId,
        netIdCopiedFax: params,
        copiedFromQueue: "",
      }
      if (selectedQueue.sectionType === "queue") {
        obj = {
          queueName: selectedQueue?.queue,
          copiedFromQueue: selectedQueue?.queue,
          queueCopiedFax: params,
        }
      }

      handleCopySubmit(
        {
          ...obj,
          subFolder: "Trash",
        },
        "trash"
      )
    }
  }

  const handleCancelFax = async (fax) => {
    setActionLoading(true)
    try {
      await post(
        "/fax/cancel",
        {
          userId: selectedQueue?.userId,
          faxId: fax?.fax_id,
        },
        {
          appId: selectedQueue?.appId,
        }
      )

      toast.success("Fax has been cancelled successfully", {
        duration: 5000,
      })
      setActionLoading(false)
      setShowCancelPopup(null)
      // fetchFaxes()
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
      setActionLoading(false)
      setShowCancelPopup(null)
    }
  }

  const handleUnreadFax = async (fax) => {
    let faxAction = IN_OUT_BOUND.outbound
    if (tab === "inbound") {
      faxAction = IN_OUT_BOUND.inbound
    }

    setActionLoading(true)
    try {
      await remove(
        `/fax/mark-as-unread?faxId=${fax?.fax_id}&faxAction=${faxAction}`
      )

      toast.success("Fax has been unread successfully", {
        duration: 5000,
      })
      setActionLoading(false)
      setShowUnreadPopup(null)
      fetchFaxes()
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
      setActionLoading(false)
      setShowUnreadPopup(null)
    }
  }

  const handleCommentAddEdit = async (data) => {
    setActionLoading(true)
    try {
      await post(`/fax/inbound/comment`, {
        faxId: data?.faxId,
        comment: data?.comment,
        userId: selectedQueue.userId,
        field: data?.commentKey,
      })

      toast.success(
        `Comment has been ${
          data?.action === "edit" ? "updated" : "added"
        } successfully`,
        {
          duration: 5000,
        }
      )
      setActionLoading(false)
      setAddCommentPopup(null)
      setEditCommentPopup(null)
      fetchFaxes()
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
      setActionLoading(false)
      setAddCommentPopup(null)
      setEditCommentPopup(null)
    }
  }

  const handleDeleteComment = async (deleteCommentPopup) => {
    setActionLoading(true)
    try {
      await remove(
        `/fax/inbound/${deleteCommentPopup?.fax_id}/comment/${deleteCommentPopup?.commentKey}`
      )

      toast.success("Comment has been removed successfully", {
        duration: 5000,
      })
      setActionLoading(false)
      setDeleteCommentPopup(null)
      fetchFaxes()
    } catch (error) {
      toast.error(error, {
        duration: 5000,
      })
      setActionLoading(false)
      setDeleteCommentPopup(null)
    }
  }

  const handleAddOrEditPhonebook = async (data) => {
    setActionLoading(true)
    try {
      await post("/phoneBook/save", {
        firstName: data.firstName,
        lastName: data.lastName,
        emailAddress: data.emailAddress,
        company: data.company,
        faxNumber: data.faxNumber,
        queue: data.queue,
        type: data.type,
      })

      setShowPhonebookPopup(false)
      setActionLoading(false)

      toast.success(`Phonebook has been added successfully`, {
        duration: 5000,
      })
    } catch (error) {
      setActionLoading(false)
      toast.error(error, {
        duration: 5000,
      })
    }
  }

  // Handlers
  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }))
  }

  const handleFaxClick = (faxId) => {
    setFaxes((prevFaxes) =>
      prevFaxes.map((fax) =>
        fax.fax_id === faxId || fax.faxId === faxId
          ? { ...fax, fax_read: true }
          : fax
      )
    )
  }

  const reloadFaxes = async (notifyError = false, fromSearch = false) => {
    setSelectedFax(null)
    setListLoading(true)
    await fetchFaxes(notifyError, fromSearch)
    setListLoading(false)
  }

  const preprarePermissions = (queuePermissions = null) => {
    const result = {}

    Object.entries(allPermissions).forEach(([category, permissionsObj]) => {
      result[category] = {}

      Object.keys(permissionsObj).forEach((permKey) => {
        const hasPermission = queuePermissions
          ? queuePermissions?.[category]?.includes(permKey) || false
          : true

        result[category][permKey] = hasPermission
      })
    })

    return result
  }

  const getNestedValue = (obj, path) =>
    path.split(".").reduce((acc, key) => acc?.[key], obj)

  useEffect(() => {
    if (selectedQueue && paginationOffset === 0) reloadFaxes(true)
    setPaginationOffset(0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQueue, tab, reloadKey])

  useEffect(() => {
    reloadFaxes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationOffset])

  useEffect(() => {
    if (showFFPopup) {
      fetchDestinationFaxNumbers()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFFPopup])

  useEffect(() => {
    const dateSortKey =
      selectedQueue?.type === "subfolder"
        ? "completedTimestamp"
        : "completed_timestamp"

    setSortConfig({
      key: dateSortKey,
      direction: "desc",
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQueue])

  useEffect(() => {
    if (tab !== "inbound") return

    const prevSearchBy = prevSearchByRef.current
    const prevSearchText = prevSearchTextRef.current

    if (
      (prevSearchBy === "originating_fax_tsid" &&
        searchBy !== "originating_fax_tsid" &&
        prevSearchText !== "") ||
      (searchBy === "date" && dateRange?.length > 0) ||
      prevSearchBy === "date"
    ) {
      setPaginationOffset(0)
      reloadFaxes(true, true)
    }

    if (searchBy === "originating_fax_tsid" && searchText !== prevSearchText) {
      setPaginationOffset(0)
      const delayDebounce = setTimeout(() => {
        reloadFaxes(true, true)
      }, 500)

      return () => clearTimeout(delayDebounce)
    }
  }, [searchBy, searchText, dateRange])

  //  Update refs after logic runs
  useEffect(() => {
    prevSearchByRef.current = searchBy
    prevSearchTextRef.current = searchText
  }, [searchBy, searchText])

  const renderViewAction = (actionPermissions, fax, skipPermission = false) => {
    return (
      <>
        {(skipPermission ||
          actionPermissions?.READ?.FAX_VIEW ||
          actionPermissions?.READ?.FAX_HISTORY_VIEW) && (
          <span
            onClick={(e) => {
              e.stopPropagation()
              setFaxView(fax)
              handleFaxClick(fax.fax_id)
            }}
            style={{
              marginLeft: "10px",
              cursor: "pointer",
            }}
            title="View Fax"
          >
            <View size={18} color="#2E59D7" />
          </span>
        )}
      </>
    )
  }

  const renderDownloadAction = (
    actionPermissions,
    fax,
    skipPermission = false
  ) => {
    return (
      <>
        {(actionPermissions.READ.FAX_DOWNLOAD || skipPermission) && (
          <span
            onClick={(e) => {
              e.stopPropagation()
              downloadPdf(fax)
            }}
            style={{
              marginLeft: "10px",
              cursor: "pointer",
            }}
            title="Download"
          >
            {loadingDownload === fax.fax_id ? (
              <RefreshCcw
                size={18}
                color="grey"
                style={{
                  animation: "spin 1s linear infinite",
                  transformOrigin: "center",
                }}
              />
            ) : (
              <Download size={18} color="#1e7dc1ff" />
            )}
          </span>
        )}
      </>
    )
  }

  const renderPermenentDeleteAction = (fax) => {
    return (
      <>
        <span
          onClick={(e) => {
            e.stopPropagation()
            setFaxToTrash({
              faxId: fax.faxId || fax.fax_id,
              userId: selectedQueue.userId,
              netId: selectedQueue.netId,
              queueName: selectedQueue.queueName,
              subFolder: selectedQueue.subFolder,
              ...fax,
            })
          }}
          title="Delete"
          style={{
            marginLeft: "10px",
            cursor: "pointer",
          }}
        >
          <Trash2 size={18} color="red" />
        </span>
      </>
    )
  }

  return (
    <div>
      {listLoading ? (
        <div className="loading-container-fax-list">
          <div className="loading-message">Loading...</div>
        </div>
      ) : (
        <>
          {/* Faxes List */}
          {!selectedQueue ? (
            <div>
              <div style={{ display: "flex", margin: "20px" }}>
                <ArrowBigLeft size={18} color="grey" />
                <span style={{ marginLeft: "5px" }}>
                  Please select Queue, NetId or Subfolder from left panel
                </span>
              </div>
            </div>
          ) : (
            <div className="faxes-content">
              {selectedQueue?.type === "subfolder" && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      marginTop: "10px",
                      marginBottom: "15px",
                    }}
                  >
                    <label className="radio-option-label">
                      <input
                        type="radio"
                        value="test"
                        checked={copiedFaxType === "INBOUND"}
                        onChange={() => setCopiedFaxType("INBOUND")}
                      />
                      INBOUND
                    </label>
                    <label className="radio-option-label">
                      <input
                        type="radio"
                        value="prod"
                        checked={copiedFaxType === "OUTBOUND"}
                        onChange={() => setCopiedFaxType("OUTBOUND")}
                      />
                      OUTBOUND
                    </label>
                  </div>
                </div>
              )}
              <div className="table-wrapper-sticky">
                <table className="faxes-table-sticky">
                  <thead>
                    <tr>
                      {fields.map((field, i) => {
                        if (field.hide) {
                          return <></>
                        }

                        if (
                          selectedQueue?.type === "subfolder" &&
                          copiedFaxType === "OUTBOUND" &&
                          field.showFor === "INBOUND"
                        ) {
                          return <></>
                        }

                        if (
                          selectedQueue?.type === "subfolder" &&
                          copiedFaxType === "INBOUND" &&
                          field.showFor === "OUTBOUND"
                        ) {
                          return <></>
                        }

                        return (
                          <th
                            key={field.key}
                            className={`faxes-th-sticky`}
                            style={{ cursor: "pointer", ...field.style }}
                            onClick={() => {
                              if (field.sort) handleSort(field.key)
                            }}
                          >
                            <div style={{ display: "flex" }}>
                              <span>
                                {field?.ffLabel && tab === "inbound"
                                  ? field?.ffLabel
                                  : field.label}
                              </span>
                              <span style={{ marginLeft: "5px" }}>
                                {field.sort ? (
                                  sortConfig.key === field.key ? (
                                    sortConfig.direction === "asc" ? (
                                      <ArrowUp size={14} color="grey" />
                                    ) : (
                                      <ArrowDown size={14} color="grey" />
                                    )
                                  ) : (
                                    <ArrowDownUp size={14} color="grey" />
                                  )
                                ) : (
                                  ""
                                )}
                              </span>
                            </div>
                          </th>
                        )
                      })}

                      {/* {selectedQueue.parentKey !== "sharedNetIdData" && ( */}
                      <th
                        className="faxes-th-sticky"
                        style={{ width: "180px", textAlign: "left" }}
                      >
                        Actions
                      </th>
                      {/* )} */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentFaxes.length > 0 ? (
                      currentFaxes.map((fax, i) => {
                        let actionPermissions = selectedQueue?.permissions
                        if (fax?.copiedFromQueue) {
                          actionPermissions =
                            preprarePermissions(
                              queueList.queueLevelData.find(
                                (q) => q.queue === fax.copiedFromQueue
                              )?.permissions
                            ) || selectedQueue?.permissions
                        }

                        if (fax.fax_trashed) return <></>

                        const showPhonebookAction =
                          selectedQueue?.type === "folder" &&
                          selectedQueue?.parentKey !== "sharedNetIdData" &&
                          selectedQueue?.parentKey !== "userPersonalFax"

                        return (
                          <tr
                            key={`${fax?.fax_id}_${i}`}
                            className={`${
                              fax?.fax_read === false ? "font-bold" : ""
                            }`}
                          >
                            {fields.map((field, i) => {
                              if (field.hide) {
                                return <></>
                              }

                              if (
                                selectedQueue?.type === "subfolder" &&
                                copiedFaxType === "OUTBOUND" &&
                                field.showFor === "INBOUND"
                              ) {
                                return <></>
                              }

                              if (
                                selectedQueue?.type === "subfolder" &&
                                copiedFaxType === "INBOUND" &&
                                field.showFor === "OUTBOUND"
                              ) {
                                return <></>
                              }

                              let f = getNestedValue(fax, field.key)

                              // Inbound faxnumber display
                              const faxNumberToDisplayTsid = !isEmpty(
                                fax?.originating_fax_tsid,
                                true
                              )
                                ? fax.originating_fax_tsid
                                : !isEmpty(fax?.originating_fax_number, true)
                                ? fax?.originating_fax_number
                                : ""

                              // Outbound faxnumber display
                              const faxNumberToDisplayCsid = !isEmpty(
                                fax?.destination_fax_csid,
                                true
                              )
                                ? fax.destination_fax_csid
                                : !isEmpty(fax?.destination_fax_number, true)
                                ? fax?.destination_fax_number
                                : ""

                              if (field.fixed) {
                                let fixedColumnValue = getNestedValue(
                                  fax,
                                  field.key
                                )

                                if (field?.key === "destination_fax_csid") {
                                  fixedColumnValue = faxNumberToDisplayCsid
                                }

                                f = (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span>
                                      {formatFaxNumber(fixedColumnValue)}
                                    </span>

                                    {showPhonebookAction && (
                                      <span
                                        title="Add to phonebook"
                                        style={{ marginLeft: "30px" }}
                                      >
                                        <PhoneForwarded
                                          size={14}
                                          color="#218304ff"
                                          onClick={() =>
                                            setShowPhonebookPopup(
                                              formatFaxNumber(fixedColumnValue)
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    )}
                                  </div>
                                )
                              } else if (
                                field?.key === "createdTimestamp" ||
                                field?.key === "completed_timestamp"
                              ) {
                                f = moment
                                  .utc(fax[field.key])
                                  .tz("America/New_York")
                                  .format("MM/DD/YYYY hh:mm A")
                              } else if (
                                field?.key === "destination_fax_csid"
                              ) {
                                f = faxNumberToDisplayCsid
                              }

                              if (
                                field?.key ===
                                  "transmission_data.transmission_status" &&
                                fax?.transmission_data?.transmission_status ===
                                  "ERROR"
                              ) {
                                f = `${fax?.transmission_data?.transmission_status} - ${fax?.transmission_data?.error_message}`
                              }

                              if (field?.key === "originating_fax_tsid") {
                                f = (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span>
                                      {formatFaxNumber(faxNumberToDisplayTsid)}
                                    </span>
                                    {showPhonebookAction && (
                                      <span
                                        title="Add to phonebook"
                                        style={{ marginLeft: "30px" }}
                                      >
                                        <PhoneForwarded
                                          size={14}
                                          color="#218304ff"
                                          onClick={() =>
                                            setShowPhonebookPopup(
                                              formatFaxNumber(
                                                faxNumberToDisplayTsid
                                              )
                                            )
                                          }
                                          style={{ cursor: "pointer" }}
                                        />
                                      </span>
                                    )}
                                  </div>
                                )
                              }

                              if (field?.key === "displayFaxNumber") {
                                f = formatFaxNumber(fax.displayFaxNumber)
                              }

                              if (field?.key === "faxNumber") {
                                f = formatFaxNumber(fax.faxNumber)
                              }

                              if (field?.key === "routing_data") {
                                f = `${fax?.routing_data?.to_name} - ${fax?.routing_data?.to_company}`
                              }

                              if (field?.key === "muscSender") {
                                const clientRef =
                                  fax?.client_tracking_data?.client_reference_id

                                if (clientRef && clientRef.includes("_$$_")) {
                                  const [field1] = clientRef.split("_$$_")
                                  f = `${field1}`
                                } else {
                                  f = ""
                                }
                              }

                              if (
                                field?.key === "comment1" ||
                                field?.key === "comment2" ||
                                field?.key === "comment3"
                              ) {
                                // pick the right comment value dynamically
                                const commentValue = fax?.[field.key]
                                const showCrudActions =
                                  selectedQueue?.parentKey !==
                                    "sharedNetIdData" &&
                                  selectedQueue?.type !== "subfolder"

                                f = (
                                  <div
                                    className={`comment-cell ${
                                      commentValue
                                        ? "has-comment"
                                        : "no-comment"
                                    }`}
                                  >
                                    {commentValue ? (
                                      <>
                                        <span className="comment-text">
                                          {commentValue}
                                        </span>
                                        {showCrudActions && (
                                          <span className="comment-actions">
                                            <span title="Edit">
                                              <SquarePen
                                                size={16}
                                                color="green"
                                                onClick={() =>
                                                  setEditCommentPopup({
                                                    ...fax,
                                                    commentKey: field.key,
                                                  })
                                                }
                                              />
                                            </span>
                                            <span title="Remove">
                                              <SquareX
                                                size={16}
                                                color="red"
                                                onClick={() =>
                                                  setDeleteCommentPopup({
                                                    ...fax,
                                                    commentKey: field.key,
                                                  })
                                                }
                                              />
                                            </span>
                                          </span>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {showCrudActions && (
                                          <span title="Add Comment">
                                            <SquarePlus
                                              size={16}
                                              color="#bca50f"
                                              onClick={() =>
                                                setAddCommentPopup({
                                                  ...fax,
                                                  commentKey: field.key,
                                                })
                                              }
                                              style={{ cursor: "pointer" }}
                                            />
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </div>
                                )
                              }

                              /* title */
                              let titleText = ""
                              if (
                                field?.key ===
                                  "transmission_data.transmission_status" &&
                                fax?.transmission_data?.transmission_status ===
                                  "ERROR"
                              ) {
                                titleText = `Billable Retries: ${fax?.billable_retries}`
                              }

                              const isFaxIdColumn =
                                field?.key === "fax_id" ||
                                field?.key === "faxId"
                                  ? true
                                  : false

                              if (isFaxIdColumn) {
                                titleText = fax?.fax_id || fax?.faxId
                              }

                              return (
                                <td
                                  key={field.key}
                                  className={`faxes-td-sticky ${
                                    isFaxIdColumn
                                      ? "faxes-td-limit"
                                      : "faxes-td"
                                  }`}
                                  title={titleText}
                                  style={field.style}
                                >
                                  {f}
                                </td>
                              )
                            })}

                            {/* {dateRange.length > 0 &&
                            selectedQueue?.type !== "subfolder" &&
                            tab === "inbound" ? (
                              <td
                                className="faxes-td-sticky"
                                style={{ textAlign: "left" }}
                              >
                                {renderViewAction(actionPermissions, fax)}
                                {renderDownloadAction(actionPermissions, fax)}
                              </td>
                            ) : ( */}

                            {selectedQueue?.faxNumber === PERSONAL_FAX ||
                            selectedQueue?.parentKey === "userPersonalFax" ? ( // Personal fax: actions
                              tab === "outbound" && (
                                <td
                                  className="faxes-td-sticky"
                                  style={{ textAlign: "left" }}
                                >
                                  {renderViewAction(
                                    actionPermissions,
                                    fax,
                                    true
                                  )}
                                  {renderDownloadAction(
                                    actionPermissions,
                                    fax,
                                    true
                                  )}
                                  {selectedQueue?.parentKey !==
                                    "userPersonalFax" && (
                                    <>{renderPermenentDeleteAction(fax)}</>
                                  )}
                                </td>
                              )
                            ) : (
                              // Folder & Subfolder : actions
                              <>
                                {selectedQueue?.type !== "subfolder" &&
                                  (tab === "inbound" || tab === "outbound") && (
                                    <td
                                      className="faxes-td-sticky"
                                      style={{ textAlign: "left" }}
                                    >
                                      {renderViewAction(actionPermissions, fax)}

                                      {/* )} */}
                                      {actionPermissions.WRITE.FAX_FORWARD && (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setShowFFPopup(fax)
                                          }}
                                          style={{
                                            marginLeft: "10px",
                                            cursor: "pointer",
                                          }}
                                          title="Forward to Fax"
                                        >
                                          <StepForward
                                            size={18}
                                            color="green"
                                          />
                                        </span>
                                      )}

                                      {renderDownloadAction(
                                        actionPermissions,
                                        fax
                                      )}

                                      {!fax?.fax_copied ? (
                                        <>
                                          {actionPermissions.WRITE.FAX_COPY && (
                                            <span
                                              onClick={(e) => {
                                                e.stopPropagation()
                                                setFaxToCopy(fax)
                                              }}
                                              title="Copy"
                                              style={{
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <Copy size={18} color="purple" />
                                            </span>
                                          )}
                                        </>
                                      ) : (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                          }}
                                        >
                                          ✅ Copied
                                        </span>
                                      )}

                                      {tab === "outbound" &&
                                        ["NEW", "INPROGRESS"].includes(
                                          fax?.transmission_data
                                            ?.transmission_status
                                        ) && (
                                          <span
                                            onClick={(e) => {
                                              setShowCancelPopup(fax)
                                            }}
                                            style={{
                                              marginLeft: "10px",
                                              cursor: "pointer",
                                            }}
                                            title="Cancel Fax"
                                          >
                                            <FileX size={18} color="brown" />
                                          </span>
                                        )}

                                      {fax.fax_read && (
                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            setShowUnreadPopup(fax)
                                          }}
                                          style={{
                                            marginLeft: "10px",
                                            cursor: "pointer",
                                          }}
                                          title="Unread Fax"
                                        >
                                          <EyeOff size={18} color="black" />
                                        </span>
                                      )}

                                      {!fax.fax_trashed && (
                                        <>
                                          {actionPermissions.DELETE
                                            .FAX_DELETE && (
                                            <span
                                              onClick={(e) => {
                                                e.stopPropagation()
                                                setFaxToTrash({
                                                  faxId: fax.faxId,
                                                  netId: selectedQueue.netId,
                                                  queueName:
                                                    selectedQueue.queueName,
                                                  ...fax,
                                                })
                                              }}
                                              style={{
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                              }}
                                              title="Delete"
                                            >
                                              <Trash2 size={18} color="red" />
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </td>
                                  )}
                                {selectedQueue?.type === "subfolder" && (
                                  <td
                                    className="faxes-td"
                                    style={{ textAlign: "left" }}
                                  >
                                    {(actionPermissions?.READ?.FAX_VIEW ||
                                      actionPermissions?.READ
                                        ?.FAX_HISTORY_VIEW) && (
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          setFaxView({
                                            ...fax,
                                            permissions: actionPermissions,
                                          })
                                        }}
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        title="View Fax"
                                      >
                                        <View size={18} color="#2E59D7" />
                                      </span>
                                    )}

                                    <span
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        setFaxToUndo({
                                          faxId: fax.faxId,
                                          netId: selectedQueue.netId,
                                          queueName: selectedQueue.queueName,
                                          subFolder: selectedQueue.subFolder,
                                        })
                                      }}
                                      title={
                                        selectedQueue.subFolder === "Trash"
                                          ? "Move back"
                                          : "Delete"
                                      }
                                      style={{
                                        marginLeft: "10px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {selectedQueue.subFolder === "Trash" ? (
                                        <Undo2 size="18" color="green" />
                                      ) : (
                                        <Trash2 size="18" color="red" />
                                      )}
                                    </span>
                                    {selectedQueue.subFolder === "Trash" && (
                                      <>{renderPermenentDeleteAction(fax)}</>
                                    )}
                                  </td>
                                )}
                              </>
                            )}
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="100%"
                          style={{
                            textAlign: "center",
                            padding: "10px",
                            border: "1px solid #ccc",
                          }}
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* </div> */}
            </div>
          )}
          {currentFaxes.length > 0 && (
            <div
              className="faxes-pagination"
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <Pagination
                lastRecord={lastRecord}
                setPaginationOffset={setPaginationOffset}
                paginationOffset={paginationOffset}
                rowsPerPage={currentFaxes.length}
              />
            </div>
          )}
          {faxToCopy && (
            <PopupCopy
              selectedQueue={selectedQueue}
              faxToCopy={faxToCopy}
              onSave={handleCopySubmit}
              onClose={() => {
                setFaxToCopy(null)
              }}
              actionLoading={actionLoading}
              tab={tab}
              queueList={queueList}
              authUser={authUser}
            />
          )}
          {faxToUndo && (
            <UndoConfirmationPopup
              onConfirm={() => handleUndoSubmit(faxToUndo)}
              faxToUndo={faxToUndo}
              onCancel={() => setFaxToUndo(null)}
              actionLoading={actionLoading}
            />
          )}
          {faxToTrash && (
            <DeleteConfirmationPopup
              onConfirm={() => handleDeleteSubmit(faxToTrash)}
              faxToTrash={faxToTrash}
              onCancel={() => setFaxToTrash(null)}
              actionLoading={actionLoading}
              selectedQueue={selectedQueue}
            />
          )}
          {showFFPopup && (
            <SendFaxFormModal
              // onSave={handleSendFax}
              onClose={() => {
                setShowFFPopup(null)
              }}
              selectedQueue={selectedQueue}
              selectedFax={showFFPopup}
              destinationfaxNumbers={destinationfaxNumbers}
              destinationFaxNumberLoading={destinationFaxNumberLoading}
              // document={document}
            />
          )}
          {faxView && (
            <FaxView
              onClose={() => {
                setFaxView(null)
              }}
              selectedQueue={selectedQueue}
              selectedFax={faxView}
              tab={tab}
              authUser={authUser}
            />
          )}
          {showCancelPopup && (
            <CancelConfirmationPopup
              showCancelPopup={showCancelPopup}
              onConfirm={() => handleCancelFax(showCancelPopup)}
              onCancel={() => setShowCancelPopup(null)}
              actionLoading={actionLoading}
            />
          )}
          {showUnreadPopup && (
            <UnreadConfirmationPopup
              showUnreadPopup={showUnreadPopup}
              onConfirm={() => handleUnreadFax(showUnreadPopup)}
              onCancel={() => setShowUnreadPopup(null)}
              actionLoading={actionLoading}
            />
          )}
          {(addCommentPopup || editCommentPopup) && (
            <CommentPopup
              addCommentPopup={addCommentPopup}
              editCommentPopup={editCommentPopup}
              onSave={(data) => handleCommentAddEdit(data)}
              onClose={() => {
                setAddCommentPopup(null)
                setEditCommentPopup(null)
              }}
              actionLoading={actionLoading}
            />
          )}
          {deleteCommentPopup && (
            <DeleteCommentConfirmationPopup
              onConfirm={() => handleDeleteComment(deleteCommentPopup)}
              onCancel={() => setDeleteCommentPopup(null)}
              actionLoading={actionLoading}
              deleteCommentPopup={deleteCommentPopup}
            />
          )}
          {showPhonebookPopup && (
            <PhonebookModal
              onSave={handleAddOrEditPhonebook}
              actionLoading={actionLoading}
              onClose={() => {
                setShowPhonebookPopup(null)
              }}
              queueLevelData={queueList.queueLevelData}
              fromInOutBound={{
                faxNumber: showPhonebookPopup,
                type:
                  selectedQueue?.sectionType === "queue" ? "QUEUE" : "PERSONAL",
              }}
            />
          )}
        </>
      )}
    </div>
  )
}

export default BoundInOut

const PopupCopy = ({
  selectedQueue,
  faxToCopy,
  onClose,
  onSave,
  actionLoading,
  tab,
  queueList,
  authUser,
}) => {
  const [subFolders, setSubFolders] = useState([])
  const [copyTo, setCopyTo] = useState("queue")
  const [selectedNetId, setSelectedNetId] = useState(
    selectedQueue?.parentKey === "itNetIdData"
      ? queueList?.itNetIdData[0]?.netId
      : queueList?.ownNetIdData[0]?.netId || []
  )
  const [selectedFolder, setSelectedFolder] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()

    const params = {
      faxId: faxToCopy.fax_id,
      appId: selectedQueue?.appId,
      userId: selectedQueue?.userId,
      faxNumber: faxToCopy.destination_fax_number,
      pages: faxToCopy.pages,
      faxStatus: faxToCopy.fax_status,
      faxType: tab === "outbound" ? "OUTBOUND" : "INBOUND",
      displayFaxNumber:
        tab === "outbound"
          ? faxToCopy?.destination_fax_csid || faxToCopy?.destination_fax_number
          : faxToCopy.originating_fax_tsid,
      copiedFromQueue: selectedQueue?.queue || "",

      completedTimestamp: moment
        .utc(faxToCopy.completed_timestamp)
        .tz("America/New_York")
        .format("MM/DD/YYYY hh:mm A"),
      ...(tab === "outbound" && {
        outboundComment1:
          faxToCopy?.client_tracking_data?.client_matter || null,
        outboundComment2: faxToCopy?.client_tracking_data?.client_name || null,
      }),
    }

    let obj = {
      netId: selectedQueue?.netId,
      netIdCopiedFax: params,
    }

    if (selectedQueue.sectionType === "queue" && copyTo === "queue") {
      obj = {
        queueName: selectedQueue?.queue,
        queueCopiedFax: params,
      }
    }

    onSave({
      ...obj,
      subFolder: selectedFolder,
    })
  }

  const fetchFolders = async () => {
    // if (
    //   selectedQueue.sectionType !== "queue" &&
    //   authUser.loggedInUserType === "USER"
    // ) {
    //   return
    // }

    setLoading(true)
    try {
      let url = `/admin/netId-subfolder-associations?netId=${selectedQueue.netId}`
      if (selectedQueue.sectionType === "queue" && copyTo === "queue") {
        url = `/admin/queue-subfolder-associations?queueName=${selectedQueue.queue}`
      }

      const data = await get(url)

      const dataFilterTrash = data.filter((d) => d.subFolder !== "Trash")

      setSubFolders(dataFilterTrash)
      setSelectedFolder(dataFilterTrash[0].subFolder)
      setLoading(false)
    } catch (error) {
      console.error("Failed to fetch folders", error)
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchFolders()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copyTo, selectedNetId])

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">Copy Fax</h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
        <form className="popup-group" onSubmit={handleSubmit}>
          {actionLoading ? (
            <div>Copying ...</div>
          ) : (
            <>
              {/* {subFolders?.length > 0 ? (
                <> */}
              <div className="form-group">
                {selectedQueue.sectionType === "queue" &&
                  authUser.loggedInUserType === "USER" && (
                    <div className="radio-group-copy">
                      <span
                        className="radio-option-label-copy"
                        style={{ display: "flex" }}
                        onClick={() => setCopyTo("queue")}
                      >
                        <input
                          style={{ width: "unset", marginLeft: "0px" }}
                          type="radio"
                          value="faxnumber"
                          checked={copyTo === "queue"}
                        />
                        Copy to {selectedQueue?.queue}
                      </span>

                      <span
                        className="radio-option-label-copy"
                        style={{ display: "flex" }}
                        onClick={() => setCopyTo("netId")}
                      >
                        <input
                          style={{ width: "unset", marginLeft: "0px" }}
                          type="radio"
                          value="admin"
                          checked={copyTo === "netId"}
                        />
                        Copy to {queueList?.ownNetIdData[0]?.netId}
                      </span>

                      {/* <span
                      className="radio-option-label-copy"
                      style={{ display: "flex" }}
                      onClick={() => setCopyTo("itNetId")}
                    >
                      <input
                        style={{ width: "unset", marginLeft: "0px" }}
                        type="radio"
                        value="admin"
                        checked={copyTo === "itNetId"}
                      />
                      Copy to IT
                    </span> */}
                    </div>
                  )}

                {/* {copyTo === "netId" && (
                  <>
                    <label htmlFor="netid">
                      NetId: <span className="mandatory">*</span>
                    </label>
                    <select
                      id="netid"
                      className="select-dropdown"
                      onChange={(e) => {
                        setSelectedNetId(e.target.value)
                      }}
                      value={selectedNetId || ""}
                      style={{ marginBottom: "10px" }}
                    >
                      {queueList?.ownNetIdData?.map((s, i) => (
                        <option key={i} value={s.netId}>
                          {s.netId}
                        </option>
                      ))}
                    </select>
                  </>
                )} */}

                {/* {copyTo === "queue" && (
                  <> */}
                {subFolders?.length > 0 ? (
                  <>
                    {selectedQueue.permissions.READ.FOLDER_BROWSE ||
                    copyTo !== "queue" ? (
                      <>
                        <label htmlFor="subfolder">
                          To Subfolder: <span className="mandatory"></span>
                        </label>
                        <select
                          id="subfolder"
                          className="select-dropdown"
                          onChange={(e) => {
                            setSelectedFolder(e.target.value)
                          }}
                          value={selectedFolder || ""}
                        >
                          {subFolders.map((s, i) => (
                            <option key={i} value={s.subFolder}>
                              {s.subFolder}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : (
                      <>
                        <TriangleAlert
                          size={18}
                          fill="yellow"
                          stroke="black"
                          strokeWidth={2}
                        />
                        <span style={{ paddingLeft: "5px" }}>
                          No permission for copy to queue
                        </span>
                      </>
                    )}
                  </>
                ) : (
                  <div className="form-group">
                    {!loading ? `No subfolder available for assign.` : ""}
                  </div>
                )}
                {/* </>
                )} */}
              </div>
              {subFolders?.length > 0 && (
                <div className="popup-buttons" style={{ marginTop: "10px" }}>
                  {loading ? (
                    <div>Loading ...</div>
                  ) : (
                    <>
                      <button
                        className="popup-button cancel"
                        type="button"
                        onClick={onClose}
                      >
                        Cancel
                      </button>
                      {(selectedQueue.permissions.READ.FOLDER_BROWSE ||
                        copyTo !== "queue") && (
                        <button className="popup-button save" type="submit">
                          Save
                        </button>
                      )}
                    </>
                  )}
                </div>
              )}
            </>
          )}
        </form>
      </div>
    </div>
  )
}

const UndoConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  faxToUndo,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "20px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {faxToUndo?.subFolder === "Trash"
                ? `Are you sure you want to move back the fax from`
                : `Are you sure you want to delete fax from`}
              <span style={{ fontWeight: "bold" }}> {faxToUndo.subFolder}</span>
              ?
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={() => onConfirm(faxToUndo)}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const DeleteConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  faxToTrash,
  selectedQueue,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "20px", maxWidth: "700px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {faxToTrash?.subFolder === "Trash" ||
              selectedQueue?.faxNumber === PERSONAL_FAX
                ? `Are you sure you want to permanently delete this fax? Once deleted, it cannot be recovered.`
                : `Are you sure you want to move the fax to the Trash?`}
            </p>
            {faxToTrash?.subFolder === "Trash" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "20px",
                }}
              >
                <TriangleAlert
                  size={18}
                  fill="yellow"
                  stroke="black"
                  strokeWidth={2}
                />
                <span style={{ marginLeft: "5px" }}>
                  All copies of this fax in the QUEUE and NETID subfolders will
                  be deleted.
                </span>
              </div>
            )}
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={() => onConfirm(faxToTrash)}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const CancelConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  showCancelPopup,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "10px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {`Are you sure you want to cancel the fax?`}
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const UnreadConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  showUnreadPopup,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "10px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {`Are you sure you want to unread the fax?`}
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const CommentPopup = ({
  onClose,
  onSave,
  addCommentPopup,
  editCommentPopup,
  actionLoading,
}) => {
  const [comment, setComment] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const commentKey = editCommentPopup?.commentKey || addCommentPopup?.commentKey

  useEffect(() => {
    if (editCommentPopup) {
      // pick the right comment field dynamically
      const commentValue = editCommentPopup?.[editCommentPopup.commentKey]
      setComment(commentValue || "")
    }
  }, [editCommentPopup])

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!comment.trim()) {
      setErrorMessage("Comment is required.")
      return
    }

    // prepare variables first
    const faxId = editCommentPopup
      ? editCommentPopup?.fax_id
      : addCommentPopup?.fax_id

    const action = editCommentPopup?.fax_id ? "edit" : "add"

    // we passed commentKey earlier when opening the popup

    // now build params
    const params = {
      faxId,
      comment,
      action,
      commentKey,
    }

    onSave(params)
  }

  return (
    <div className="popup-overlay">
      <div className="popup">
        <div className="checkbox-popup-header">
          <h3 className="popup-title">
            {editCommentPopup ? `Update` : `Add`} {commentKey}
          </h3>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        <form className="popup-group" onSubmit={handleSubmit}>
          <div className="form-group">
            {/* <label htmlFor="comment">
              Comment: <span className="mandatory">*</span>
            </label> */}
            <input
              type="text"
              id="comment"
              value={comment}
              onChange={(e) => {
                setComment(e.target.value)
                setErrorMessage("")
              }}
              maxLength={45}
            />
          </div>

          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="popup-buttons" style={{ marginTop: "5px" }}>
            <button
              className="popup-button cancel"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button className="popup-button save" type="submit">
              {actionLoading ? `Saving ...` : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

const DeleteCommentConfirmationPopup = ({
  onConfirm,
  onCancel,
  actionLoading,
  deleteCommentPopup,
}) => {
  return (
    <div className="popup-overlay">
      <div className="popup" style={{ padding: "10px" }}>
        {actionLoading ? (
          <div>In progress ...</div>
        ) : (
          <div>
            {/* <h3>Confirm Deletion</h3> */}
            <p style={{ marginTop: "5px" }}>
              {`Are you sure you want to delete the ${deleteCommentPopup.commentKey}?`}
            </p>
            <p style={{ fontWeight: "bold" }}>
              {deleteCommentPopup?.[deleteCommentPopup.commentKey]}
            </p>
            <div className="popup-buttons">
              <button className="cancel" onClick={onCancel}>
                No
              </button>
              <button className="delete" onClick={onConfirm}>
                Yes
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
